import {
  faMapMarkerAlt as freeFasFaMapMarkerAlt,
  faCalendarAlt as freeFasFaCalendarAlt,
  faClock as freeFasFaClock,
  faEdit as freeFasFaEdit,
  faChevronDown as freeFasFaChevronDown,
  faCheck as freeFasFaCheck,
  faTasks as freeFasFaTasks,
  faGraduationCap as freeFasFaGraduationCap,
  faBars as freeFasFaBars,
  faInfo as freeFasFaInfo,
  faTools as freeFasFaTools,
  faBookOpen as freeFasFaBookOpen,
  faPlusCircle as freeFasFaPlusCircle,
  faExclamationTriangle as freeFasFaExclamationTriangle,
  faTrash as freeFasFaTrash,
  faEuroSign as freeFasFaEuroSign,
  faCircle as freeFasFaCircle,
  faTimes as freeFasFaTimes,
  faTag as freeFasFaTag,
  faHashtag as freeFasFaHashtag,
  faThumbsUp as freeFasFaThumbsUp,
  faDesktop as freeFasFaDesktop,
  faFilePdf as freeFasFaFilePdf,
  faFilePowerpoint as freeFasFaFilePowerpoint,
  faEye as freeFasFaEye,
  faPlayCircle as freeFasFaPlayCircle,
  faUser as freeFasFaUser,
  faHourglassHalf as freeFasFaHourglassHalf,
  faFilter as freeFasFaFilter,
  faRoute as freeFasFaRoute
} from '@fortawesome/free-solid-svg-icons'

import {
  faQuestionCircle as freeFarFaQuestionCircle,
  faCheckCircle as freeFarFaCheckCircle,
  faFrown as freeFarFaFrown,
  faSmile as freeFarFaSmile,
  faMeh as freeFarFaMeh
} from '@fortawesome/free-regular-svg-icons'

export default {freeFasFaMapMarkerAlt, freeFasFaCalendarAlt, freeFasFaClock, freeFasFaEdit, freeFasFaChevronDown, freeFasFaCheck, freeFasFaTasks, freeFasFaGraduationCap, freeFasFaBars, freeFasFaInfo, freeFasFaTools, freeFasFaBookOpen, freeFasFaPlusCircle, freeFasFaExclamationTriangle, freeFasFaTrash, freeFasFaEuroSign, freeFasFaCircle, freeFasFaTimes, freeFasFaTag, freeFasFaHashtag, freeFasFaThumbsUp, freeFasFaDesktop, freeFasFaFilePdf, freeFasFaFilePowerpoint, freeFasFaEye, freeFasFaPlayCircle, freeFasFaUser, freeFasFaHourglassHalf, freeFasFaFilter, freeFasFaRoute, freeFarFaQuestionCircle, freeFarFaCheckCircle, freeFarFaFrown, freeFarFaSmile, freeFarFaMeh}